/**
 * App-level connector: wires the ui/DarkModeToggle component to the useDarkMode hook.
 * Import from here anywhere in the app; import from ui/components/DarkModeToggle for
 * pure presentational usage (e.g. Storybook, tests).
 */
import { DarkModeToggle as DarkModeToggleUi } from "../../ui/components/DarkModeToggle";
import { useDarkMode } from "../lib/theme/hooks";
import { useBooleanFeatureFlag } from "../lib/featureFlags/hooks";

export type { DarkModeToggleProps } from "../../ui/components/DarkModeToggle";

export function DarkModeToggle({ placement = "fixed" }: { placement?: "fixed" | "header" }) {
  const { isDark, toggleDarkMode } = useDarkMode();
  // Default true so the toggle doesn't flicker away before flags finish loading.
  const enabled = useBooleanFeatureFlag("pro_web.dark_mode_toggle", true);
  if (!enabled) return null;
  return <DarkModeToggleUi isDark={isDark} onToggle={toggleDarkMode} placement={placement} />;
}
